//src/pages/Materials/MaterialList.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getMaterial, deleteMaterial } from "../../api/material/MaterialApi";
import { backicon, fileIcon } from "../../assets/icons/icons";
import MaterialPopup from "../../components/materials/materialPopup";
import "../dashboard/Dashboard.css";
import MaterialAssign from "./MaterialAssign";
import { IoMdArrowRoundBack } from "react-icons/io";
import { checkQuestionsExist } from "../../api/questions/questionsApi";

const MaterialList = () => {
  const { projectId } = useParams();
  const user_id = localStorage.getItem("user_id");
  const [materialList, setMaterialList] = useState([]);
  const [materialText, setMaterialText] = useState("");
  const [showMaterialText, setShowMaterialText] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [showMaterialForm, setshowMaterialForm] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [questionsExist, setQuestionsExist] = useState(false);
  const navigate = useNavigate();

  const materialHandler = (data) => {
    setMaterialText(data);
    setShowMaterialText(true);
  };

  const backButtonHandler = () => {
    navigate("/projects");
  };

  const materialAssignPopUp = (material) => {
    setSelectedMaterial(material);
    setshowMaterialForm(!showMaterialForm);
  };

  const handleDeleteProject = async (material_id) => {
    try {
      //console.log('Deleting Material ID:', material_id);
      await deleteMaterial(material_id);
      alert("material deleted successfully!");
      setRefresh((prev) => !prev);
    } catch (error) {
      alert("Failed to delete material");
      console.error("Error deleting material:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      // const response = await getMaterial(user_id, projectId);
      // const questionsRes = await checkQuestionsExist(projectId);
      // setMaterialList(response.data.data);
      // setQuestionsExist(questionsRes.data.exists);
      try {
       const response = await getMaterial(user_id, projectId);
       const exists = await checkQuestionsExist(projectId);

       setMaterialList(response?.data?.data || []);
       setQuestionsExist(exists);
     } catch (err) {
       console.error("Error fetching materials or questions existence:", err);
       setMaterialList([]);
       setQuestionsExist(false);
     }
    };
    fetchData();
  }, [user_id, projectId, refresh]);
  console.log(materialList);
  return (
    <div className="w-full mt-2">
      {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}
    <button onClick={backButtonHandler}
      className="flex items-center gap-3 px-4 py-2 rounded-full bg-gradient-to-r from-red-500 to-pink-500 text-white shadow-md 
                 hover:scale-105 hover:shadow-lg transition-all duration-300 lg:mx-60 md:mx-32 mx-3"
    >
  <IoMdArrowRoundBack className="text-2xl" />
  <span className="font-semibold hidden md:block">Back</span>
</button>
      {showMaterialForm && selectedMaterial && (
        <div className=" w-full  fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-55">
          <div className="rounded-lg shadow-sm py-3 mb-3 w-full transform transition-transform duration-500 ease-out -translate-y-10 animate-slide-in">
            <MaterialAssign
              material={selectedMaterial}
              onClose={materialAssignPopUp}
            />
          </div>
        </div>
      )}
      <div className="w-full mx-auto flex flex-col justify-items-center">
        <h2 className="text-center text-2xl md:text-3xl font-bold bg-[#36369f] text-transparent bg-clip-text mb-4">
          MATERIALS
        </h2>
        <div className="lg:w-8/12 md:w-11/12 w-full mx-auto px-2 md:px-0">
          <div className="h-[500px] overflow-y-auto ">
            <table className="min-w-full border-collapse">
              <thead className="bg-gray-100 text-white text-sm font-medium sticky top-0">
                <tr className="bg-[#36369f] py-3">
                  {/* <th className="py-3 px-4">Material</th> */}
                  <th className="md:py-3 py-1 px-4 text-left">Material Name</th>
                  <th className="md:py-3 py-1 px-4 text-left">File Name</th>
                  {/* <th className="md:py-3 py-1 px-4 ">Assign</th> */}
                  <th className="md:py-3 py-1 px-4 ">Created Date</th>
                      {!questionsExist && (
                  <th className="md:py-3 py-1 px-4 text-center">Actions</th>
                  )}
                </tr>
              </thead>
              <tbody className="bg-white shadow-[inset_0px_4px_10px_rgba(0,0,0,0.1)]">
                {materialList.length > 0 ? (
                  materialList.map((material) => (
                    <tr
                      key={material?.material_id}
                      className="border-b border-gray-200 hover:bg-gray-50 md:text-base text-sm cursor-pointer"
                    >
                      {/* <td onClick={() => materialHandler(material?.material_text)} className="p-4 font-bold">
                    <img
                      className="w-10 h-10 ml-2 my-2"
                      src={fileIcon}
                      alt="file image"
                    />
                  </td> */}
                      <td className="md:py-4 py-2 px-4 font-bold">
                        {material?.material_name}
                      </td>
                      <td className="md:py-4 py-2 px-4">{material?.material_file_name}</td>
                      {/* <td className="md:py-4 py-2 px-4 text-center">
                        <button
                          onClick={() => materialAssignPopUp(material)}
                          className="bg-[#6C63FF] text-white md:px-6 px-3 py-1 rounded-lg mx-auto md:text-sm text-xs "
                        >
                          Assign
                        </button>
                      </td> */}
                      <td className="md:py-4 py-2 px-4 font-bold text-center">
                        {new Date(material.posted_date).toLocaleDateString()}
                      </td>
                      {!questionsExist && (
                      <td className="md:py-4 py-2 px-4 text-center">
                        <button
                          onClick={() => handleDeleteProject(material?.material_id)}
                          className="bg-red-500 text-white md:px-4 px-3 py-1 rounded-lg md:text-sm text-xs hover:bg-red-600"
                        >
                          Delete
                        </button>
                      </td>
                    )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={questionsExist ? 3 : 4}
                      className="text-center text-xl font-semibold text-gray-600 my-2"
                    >
                      No Materials available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <MaterialPopup
          materialText={materialText}
          show={showMaterialText}
          onClose={() => setShowMaterialText(false)}
        />
      </div>
    </div>
  );
};

export default MaterialList;